// Element UI calcula la altura antes que el ancho en doLayout. Cuando cambia
// el scroll horizontal o la cabecera, la capa fija puede conservar la altura
// anterior. Sincronizarla tras renderizar evita recortar la última fila.
export default {
  install(Vue) {
    Vue.component("ElTable").mixin({
      updated() {
        if (!this.shouldUpdateHeight || !this.$el.offsetWidth) return;

        const { layout } = this;
        const tableHeight = this.$el.clientHeight;
        const headerHeight = this.showHeader
          ? this.$refs.headerWrapper.offsetHeight
          : 0;
        const footerHeight = this.$refs.footerWrapper
          ? this.$refs.footerWrapper.offsetHeight
          : 0;
        const viewportHeight = tableHeight -
          (layout.scrollX && this.data.length ? layout.gutterWidth : 0);

        if (layout.tableHeight !== tableHeight ||
            layout.headerHeight !== headerHeight ||
            layout.footerHeight !== footerHeight ||
            layout.viewportHeight !== viewportHeight) {
          layout.updateElsHeight();
        }
      },
    });
  },
};
